import React from "react";
import { Button, useDisclosure } from "@chakra-ui/react";
import { BiEditAlt } from "react-icons/bi";
import { Modal } from "components";
import { SelectionContext } from "../../../../duck";
import AuthorizationForm from "../form";
import { useRenameAuthorizationSetting } from "./duck";

const Rename: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { selected, select } = React.useContext(SelectionContext);
  const onSubmit = useRenameAuthorizationSetting(selected[0], () => {
    select([]);
    onClose();
  });

  return (
    <>
      <Button
        onClick={onOpen}
        disabled={selected.length !== 1}
        leftIcon={<BiEditAlt />}
        colorScheme="minor"
      >
        Rename
      </Button>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title="Rename Authorization condition"
      >
        <AuthorizationForm
          onCancel={onClose}
          onSubmit={onSubmit}
          authorization={selected[0]}
        />
      </Modal>
    </>
  );
};

export default Rename;
